// JS file for CurrentIssueItem
